import type { Course as CourseSchema } from 'schema-dts';

export type CoursePrice = 'FREE' | 'AUDITABLE' | 'PART_OF_COURSERA_PLUS';

export const CoursePrices = {
  Free: 'FREE',
  PartOfCourseraPlus: 'PART_OF_COURSERA_PLUS',
  Auditable: 'AUDITABLE',
} as const;

// NOTE: ideally `CourseRichSearchCard` could just be `CourseSchema`, but:
// 1. there are properties that are not required by schema.org that google requires
// 2. CourseSchema doesn't seem to include the `syllabusSections` section for some reason
export type CourseRichSearchCard = CourseSchema & {
  '@context': 'https://schema.org/';
  '@id': string;
  '@type': string;
  name: string;
  description: string;
  publisher: {
    '@type': 'Organization';
    name: string;
    url: string;
  };
  provider: {
    '@type': 'Organization';
    name: string;
    url?: string;
  };
  image: string[];
  aggregateRating?: {
    '@type': 'AggregateRating';
    ratingValue: string | number;
    bestRating: string | number;
    ratingCount: number;
  };
  offers: {
    '@type': 'Offer';
    category: 'Free' | 'Partially Free' | 'Subscription';
  };
  educationalLevel: 'Advanced' | 'Intermediate' | 'Beginner' | 'Mixed';
  totalHistoricalEnrollment?: number;
  about: string[];
  teaches: string[];
  inLanguage?: string;
  availableLanguage?: string[];
  review?: {
    '@type': 'Review';
    author: {
      '@type': 'Person';
      name: string;
    };
    datePublished: string;
    reviewBody: string;
    reviewRating: {
      '@type': 'Rating';
      bestRating: string | number;
      ratingValue: string | number;
    };
  }[];
  syllabusSections: {
    '@type': 'Syllabus';
    name: string;
    description?: string;
    timeRequired?: string;
  }[];

  coursePrerequisites: (
    | string
    | {
        '@type': 'Course';
        '@id': string;
        name: string;
        description: string;
      }
  )[];
  educationalCredentialAwarded: {
    '@type': 'EducationalOccupationalCredential';
    name: string;
    url?: string;
  };
  financialAidEligible?: string;
  video?: {
    contentUrl: string;
    thumbnailUrl: string;
  };
  hasCourseInstance: {
    '@type': 'CourseInstance';
    courseMode: 'Online';
    courseWorkload: string;
    instructor?: {
      '@type': 'Person';
      name: string;
      description?: string;
      image?: string;
    };
  }[];
};
